import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import enLocale from './en_us'
import zhLocale from './zh_cn'

Vue.use(VueI18n)

const messages = {
  en_us: {
    ...enLocale,
    ...elementEnLocale
  },
  zh_cn: {
    ...zhLocale,
    ...elementZhLocale
  }
}
Vue.prototype.langDefaultVal = {
  en_us: '',
  zh_cn: ''
};
const defaultKey = 'zh_cn';
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || defaultKey,
  // set locale messages
  messages
})
Vue.prototype.getTableHeight = function (top) {
  return window.innerHeight - top;
}
Vue.prototype.getBase64 = function (file) {
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();
    let imgResult = "";
    reader.readAsDataURL(file);
    reader.onload = function () {
      imgResult = reader.result;
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.onloadend = function () {
      resolve(imgResult);
    };
  });
}
Vue.prototype.field = function (value) {
  if (value == null || value == undefined) {
    return "";
  }
  try {
    if (!value.hasOwnProperty(this.$i18n.locale)) {
      return value[defaultKey];
    }
    if (value[this.$i18n.locale] == "" || value[this.$i18n.locale] == null) {
      return value[defaultKey];
    }
    return value[this.$i18n.locale];
  } catch {
    return value[defaultKey];
  }

}
Vue.prototype.clone = function (o) {
  if (!o) return ''
  return JSON.parse(JSON.stringify(o))
}
export default i18n